import core from "../web-sh/src/services/core";

export default {
  ...core,
}